<template>
  <div>
    <b-navbar v-show="loggedIn" toggleable="lg" type="light" fixed="top">
      <b-navbar-brand href="/">CHL Analytics</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item v-if="isAdmin" to="/stats">Statistics</b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-button size="sm" class="m-1" variant="success" @click="openPage('mainGraph')">Advanced</b-button>
          <b-button
            :disabled="setIds.length <= 1"
            class="m-1"
            :variant="setIds.length <= 1 ? 'danger' : 'success'"
            size="sm"
            @click="openLinePdf"
            >Line Graph</b-button
          >
          <b-button
            :disabled="setIds.length <= 0"
            class="m-1"
            :variant="setIds.length <= 0 ? 'danger' : 'success'"
            size="sm"
            @click="openGridVue"
            >Grid View</b-button
          >

          <b-dropdown class="m-1" size="sm" text="Offline Access" variant="success">
            <b-dropdown-item :disabled="setIds.length <= 0" @click="saveList">Save Current Selection</b-dropdown-item>
            <b-dropdown-item :disabled="savedList.length <= 0" @click="restoreList">Restore Selection</b-dropdown-item>
          </b-dropdown>

          <b-button
            :disabled="setIds.length <= 1"
            class="m-1"
            :variant="setIds.length <= 1 ? 'danger' : 'success'"
            size="sm"
            @click="openMultiPdf"
            >Multi PDF</b-button
          >

          <b-button
            :disabled="setIds.length <= 0"
            class="m-1"
            :variant="setIds.length <= 0 ? 'danger' : 'success'"
            size="sm"
            @click="saveExcel"
            >Save as Excel</b-button
          >

          <b-button class="m-1" variant="success" size="sm" v-b-toggle.sidebar>
            <b-icon-gear-fill style="font-size: 1.3em" />
          </b-button>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <settings />
  </div>
</template>

<script>
import { saveJsonToExcel } from "../modules/excel";
import { mapMutations, mapGetters, mapActions } from "vuex";
import Settings from "./Settings.vue";

export default {
  components: { Settings },
  name: "navbar",

  data() {
    return {
      savedList: [],
      savedAddresses: [],
      cropName: "",
    };
  },
  methods: {
    openLinePdf() {
      let crops = Array.from(new Set(this.allRecords.map(x => x.cropName)));
      if (crops.length > 1) {
        return this.notify({
          variant: "warn",
          message: "You are limited to one crop type for the line PDF.",
        });
      }
      if (!this.linePdf) {
        this.openPage("linePdf");
      } else {
        this.closePage("linePdf");
      }
    },
    openGridVue() {
      if (!this.gridVue) {
        this.openPage("gridVue");
      } else {
        this.closePage("gridVue");
      }
    },
    openMultiPdf() {
      if (!this.multiPdf) {
        this.openPage("multiPdf");
      } else {
        this.closePage("multiPdf");
      }
    },
    saveExcel() {
      let currentRecords = [...this.orderedRecords];
      currentRecords = currentRecords.map(x => {
        delete x.externalId;
        delete x.businessId;
        delete x.setId;
        delete x.selected;
        delete x.id;
        let values = {};
        x.values.reverse();
        for (let val of x.values) {
          values[val.name] = val.value;
        }
        delete x.values;
        return { ...x, ...values };
      });
      saveJsonToExcel(currentRecords);
    },
    saveList() {
      localStorage.recordList = JSON.stringify(this.allRecords);
      localStorage.addresses = JSON.stringify(this.addresses);
      this.savedList = [...this.allRecords];
    },
    restoreList() {
      this.setCurrentSearchResults(this.savedList);
      this.setCurrentAddresses(this.savedAddresses);
      this.setCurrentList(this.searchResults.filter(x => x.selected).map(x => x.externalId));
    },
    ...mapMutations(["setCurrentSearchResults", "setCurrentAddresses", "setCurrentList", "openPage", "closePage"]),
    ...mapActions(["notify"]),
  },
  computed: {
    ...mapGetters({
      searchResults: "currentSearchResults",
      addresses: "currentAddresses",
      currentRecords: "currentRecordList",
      allRecords: "allRecords",
      orderedRecords: "orderedRecords",
      setIds: "currentSetIds",
      loggedIn: "loggedIn",
      linePdf: "linePdf",
      gridVue: "gridVue",
      isAdmin: "isAdmin",
      multiPdf: "multiPdf",
    }),
  },
  mounted() {
    try {
      this.savedList = JSON.parse(localStorage.recordList);
      this.savedAddresses = JSON.parse(localStorage.addresses);
    } catch (error) {
      // forget it
    }
  },
};
</script>

<style lang="scss" scoped></style>
